module.exports = __webpack_public_path__ + "assets/images/cutline-configuration.2f93559c5fb66394d90d666168c06d7b.svg";